import { useRef, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { noop } from 'lodash';
import { selectIsSomeOverlayOpen } from 'reducers/app/selectors';
import Platform from 'platform';
import keys from 'config/keys';

const useOnBackClickHandler = (handler = noop) => {
  const match = useRouteMatch();
  const handlerRef = useRef(handler);
  const isSomeOverlayOpen = useSelector(selectIsSomeOverlayOpen);
  const isRootPage = match.path === '/';

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const onKeydown = (e) => {
      if (e.keyCode !== Platform.getKeyCode(keys.BACK) || isSomeOverlayOpen || isRootPage) return;
      handlerRef.current();
    };

    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
  }, [isRootPage, isSomeOverlayOpen]);
};

export default useOnBackClickHandler;
